import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CalendarDate } from "@sp-crm/core";
import { getDatePresets } from "components/reports/date-presets";

type SortField =
    | "regionName"
    | "territoryCode"
    | "userCount"
    | "paidInvoiceCount"
    | "collectedCents"
    | "avgPerInvoice"
    | "royaltyOwedCents";

interface FranchiseRoyaltyReportState {
    startDate: string;
    endDate: string;
    activePreset: string | null;
    sortField: SortField;
    sortAsc: boolean;
    searchText: string;
    territoryFilter: string;
    showOnlyUnderMinimum: boolean;
}

const lastMonthPreset = getDatePresets().find(p => p.label === "Last Month");
const lastMonthRange = lastMonthPreset
    ? lastMonthPreset.getRange()
    : {
          start: CalendarDate.today,
          end: CalendarDate.today,
      };

const initialState: FranchiseRoyaltyReportState = {
    startDate: lastMonthRange.start.toString(),
    endDate: lastMonthRange.end.toString(),
    activePreset: "Last Month",
    sortField: "royaltyOwedCents",
    sortAsc: false,
    searchText: "",
    territoryFilter: "all",
    showOnlyUnderMinimum: false,
};

export const franchiseRoyaltyReportSlice = createSlice({
    name: "franchiseRoyaltyReport",
    initialState,
    reducers: {
        update: (state, action: PayloadAction<Partial<FranchiseRoyaltyReportState>>) => {
            return { ...state, ...action.payload };
        },
    },
});
